import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

export default function useGetAllArrowTypes() {
  const [loading, setLoading] = useState(true);
  const [arrows, setArrows] = useState(false);

  const { enqueueSnackbar } = useSnackbar();

  const getAllArrowTypes = () => {
    setLoading(true);
    axiosClient
      .get('/InventoryAddress/GetAllArrowTypes')
      .then(res => {
        if (res.status === 200) {
          setArrows(res.data.value);
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => enqueueSnackbar(err?.message, { variant: 'error' }))
      .finally(() => {
        setLoading(false);
      });
  };

  return [loading, arrows, getAllArrowTypes];
}
